/**
 * Decorative background glow.
 *
 * These used to be solid shapes with a 240px Tailwind blur utility. Chrome
 * rasterizes that cheaply; WebKit does not, and at devicePixelRatio 2 the
 * filter covers roughly 4x the pixels again. Because the element is `fixed`, it
 * is promoted to its own compositing layer, so the cost lands directly in the
 * first-paint path of every page that renders a Layout or the dashboard —
 * measured at ~14s of blank screen in Safari, while Chrome was unaffected. The
 * work happens in the GPU/compositor process, which is why the main thread
 * profiled as idle throughout.
 *
 * A radial-gradient produces the same soft glow with no filter pass: the
 * compositor draws it directly instead of blurring a source surface. Visually
 * equivalent, dramatically cheaper to paint.
 *
 * Verified by bisection against stamped production builds: reverting this file
 * alone reproduces the stall; restoring it alone resolves it.
 */
export default function Orbs() {
  return (
    <div className="fixed -z-10 w-screen h-screen hidden sm:inline pointer-events-none">
      <span
        className="absolute z-1 w-[50rem] h-[30rem] transform translate-x-[50%] rotate-[17deg] top-20 right-0 rounded-full"
        style={{
          backgroundImage:
            'radial-gradient(closest-side, rgba(108, 121, 255, 0.20), rgba(108, 121, 255, 0) 100%)',
        }}
      />
      <span
        className="absolute z-1 w-[50rem] h-[30rem] transform translate-x-[30%] rotate-[17deg] bottom-20 right-0 rounded-full"
        style={{
          backgroundImage:
            'radial-gradient(closest-side, rgba(229, 72, 77, 0.20), rgba(229, 72, 77, 0) 100%)',
        }}
      />
    </div>
  )
}
